// Pick the highest-resolution source available for the zoom so it doesn't
// pixelate. The displayed `image.src` is only ~1445px (sized for the gallery),
// but the <img> carries a srcset up to 4096w — use the largest entry. Falls
// back to bumping the Shopify CDN `width` param, then to image.src.
function highResSrc(image) {
  const srcset = image.getAttribute('srcset') || image.srcset || '';
  let best = null;
  let bestWidth = 0;
  srcset.split(',').forEach((part) => {
    const match = part.trim().match(/(\S+)\s+(\d+)w/);
    if (match) {
      const width = parseInt(match[2], 10);
      if (width > bestWidth) {
        bestWidth = width;
        best = match[1];
      }
    }
  });
  if (best) return best;
  try {
    const url = new URL(image.currentSrc || image.src, window.location.href);
    url.searchParams.set('width', '2048');
    return url.href;
  } catch (e) {
    return image.src;
  }
}

// create a container and set the full-size image as its background
function createOverlay(image) {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', highResSrc(image));
  overlay = document.createElement('div');
  prepareOverlay(overlay, overlayImage);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';
  };

  return overlay;
}

function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading-overlay__spinner`);
  loadingSpinner.classList.toggle('hidden');
}

function moveWithHover(image, event, zoomRatio) {
  // calculate mouse position
  const ratio = image.height / image.width;
  const container = event.target.getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

  // determine what to show in the frame
  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function magnify(image, zoomRatio) {
  const overlay = createOverlay(image);
  overlay.onclick = () => overlay.remove();
  overlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio);
  overlay.onmouseleave = () => overlay.remove();
}

function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    image.onclick = (event) => {
      magnify(image, zoomRatio);
      moveWithHover(image, event, zoomRatio);
    };
  });
}

enableZoomOnHover(2);
